module.exports = __webpack_public_path__ + "static/columnHeaders-1f3b4ed3ec7884db581caa7e91c45530.gif";